import React, { useEffect } from 'react'
import { Route, Switch, useHistory, useParams } from 'react-router-dom'
import classNames from 'classnames'
import styled from 'styled-components'
import ImportComponents from './ImportComponents'
import ImportTemplates from './ImportTemplates'
import MapFields from './MapFields'
import ConvertTemplates from './ConvertTemplates'
import ImportModels from './ImportModels'
import _ from 'lodash'

const IMPORT_COMPONENTS = 'import_components'
const IMPORT_TEMPLATES = 'import_templates'
const MAP_FIELDS = 'map_fields'
const CONVERT_TEMPLATES = 'convert_templates'
const IMPORT_MODELS = 'import_models'

const NavigationTabLink = ({
  label,
  tab,
}) => {
  const history = useHistory()
  const params = useParams()
  return (<li key={tab} className="nav-item mr-2 cursorPointer"
              onClick={() => {
                const nextPath = `/${window.tenancy}/migration/${tab}`
                history.push(nextPath)
              }}>
    <div className={classNames('nav-link',
      { active: params.tab ? params.tab === tab : tab === IMPORT_COMPONENTS },
      'border-0 h-100')} role="tab"
         aria-selected="true">{label}</div>
  </li>)
}

const BlockOfTabs = styled.div`
    background-color: ${props => props.theme.colorTable.back}
    border-color: ${props => props.theme.colorTable.back}
`
const Migration = () => {
  const history = useHistory()

  useEffect(() => {
    if (!_.get(window.knacklyAddons, 'migration', false)) {
      history.push(`/${window.tenancy}/types`)
    }
  }, [])

  return (
    <div>
      MIGRATION
      <div className="my-2 border collectionItem knackly-plain p-3">
        <ul className="nav nav-tabs text-uppercase" role="tablist">
          <NavigationTabLink label={'IMPORT COMPONENTS'}
                             tab={IMPORT_COMPONENTS}/>
          <NavigationTabLink label={'IMPORT TEMPLATES'} tab={IMPORT_TEMPLATES}/>
          <NavigationTabLink label={'MAP FIELDS'} tab={MAP_FIELDS}/>
          <NavigationTabLink label={'IMPORT MODELS'} tab={IMPORT_MODELS}/>
          <NavigationTabLink label={'CONVERT TEMPLATES'}
                             tab={CONVERT_TEMPLATES}/>
        </ul>
        <div className="tab-content">
          <BlockOfTabs
            className="tab-pane fade show active p-2 pr-3 mb-2">
            <Switch>
              <Route
                path={'/:tenancy/migration/' + IMPORT_TEMPLATES}>
                <ImportTemplates/>
              </Route>
              <Route
                path={'/:tenancy/migration/' + MAP_FIELDS}>
                <MapFields/>
              </Route>
              <Route
                path={'/:tenancy/migration/' + CONVERT_TEMPLATES}>
                <ConvertTemplates/>
              </Route>
              <Route
                path={'/:tenancy/migration/' + IMPORT_MODELS}>
                <ImportModels/>
              </Route>
              <Route
                path={[
                  '/:tenancy/migration/' + IMPORT_COMPONENTS,
                  '/:tenancy/migration/']}>
                <ImportComponents/>
              </Route>
            </Switch>
          </BlockOfTabs>
        </div>
      </div>
    </div>
  )
}

export default Migration
